import isApiError from "@insite/client-framework/Common/isApiError";
import { ServiceResult, patch } from "@insite/client-framework/Services/ApiService";

export interface RecoverUsernamePasswordParamater {
    userEmail: string;
    passwordEmail: string;
    isuserNameReset: boolean;
    isPasswordReset: boolean;
    userNotFound: boolean;
    isSuccess: boolean;
    uri: string;
    properties: {
        captchaResponse: string;
        isEmailSend?: boolean;
    };
}

export interface RecoverUsernamePasswordModel {
    uri: any;
    userEmail: any;
    passwordEmail: any;
    isUserNameReset: boolean;
    isPasswordReset: boolean;
    userNotFound: boolean;
    isSuccess: boolean;
    properties: {
        captchaResponse: string;
    };
}

const url = "api/v1/recoverusernamepassword";

export async function getUsernamePasswordInfo(
    parameter: RecoverUsernamePasswordParamater,
): Promise<ServiceResult<RecoverUsernamePasswordModel>> {
    try {
        const resultModel = await patch<RecoverUsernamePasswordModel>(`${url}`, parameter as any);
        return {
            result: resultModel,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
